/* global Swal */

// Minimal wrapper that exposes a .fire method compatible with SweetAlert2 usage
const SwalWrapper = {
  fire: (...args) => {
    return Swal.fire(...args);
  },
};

export default SwalWrapper;
